import React from 'react';
import AddFundsCard from '../features/AddFundsCard';
import ScreenWrapper from '../features/Theme/ScreenWrapper';

type Props = {
    provider?: string;
    paytikoPaymentProvider?: number;
    currentAmount?: string;
    setActiveRightTab?: Function;
};

export default function AddFundsCardScreen({
    provider,
    paytikoPaymentProvider,
    currentAmount,
    setActiveRightTab,
}: Props) {
    return (
        <ScreenWrapper>
            <AddFundsCard
                provider={provider}
                paytikoPaymentProvider={paytikoPaymentProvider}
                currentAmount={currentAmount}
                setActiveRightTab={setActiveRightTab}
            />
        </ScreenWrapper>
    );
}
